module.exports = __webpack_public_path__ + "img/taekwondo5.71c38bed.jpg";